import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { AmbulanceAssistanceComponent } from '../../../dashboard/assistances/ambulance-assistance/ambulance-assistance.component';
import { AmbulanceInternationalComponent } from '../../../dashboard/assistances/ambulance-international/ambulance-international.component';
import { AmbulanceExtranjeroComponent } from '../../../dashboard/assistances/ambulance-extranjero/ambulance-extranjero.component';


import { VialAssistanceComponent } from '../../../dashboard/assistances/vial-assistance/vial-assistance.component';
import { MapComponent } from '../../../../shared/components/map/map.component';
import { HomeDoctorComponent } from '../../../dashboard/assistances/home-doctor/home-doctor.component';
import { ReasonsLegalAssistanceComponent } from '../../../dashboard/assistances/reasons-legal-assistance/reasons-legal-assistance.component';
import { MedicalCheckupComponent } from '../../../dashboard/assistances/medical-checkup/medical-checkup.component';
import { MedicalReferencesComponent } from '../../../dashboard/assistances/medical-references/medical-references.component';
import { UrgentMessagesComponent } from '../../../dashboard/assistances/urgent-messages/urgent-messages.component';
import { MedicoDomicilioComponent } from '../../../dashboard/assistances/medico-domicilio/medico-domicilio.component';
import { DiscountNetworkComponent } from '../../../dashboard/assistances/discount-network/discount-network.component';
import { MedicalVirtualComponent } from '../../../dashboard/assistances/medical-virtual/medical-virtual.component';
import { MedicalPsicotelefonicaComponent } from '../../../dashboard/assistances/medical-psicotelefonica/medical-psicotelefonica.component';
import { MedicalComponent } from '../../../dashboard/assistances/medical/medical.component';
import { TrasladoFamiliarComponent } from '../../../dashboard/assistances/traslado-familiar/traslado-familiar.component';
import { PagoHotelComponent } from '../../../dashboard/assistances/pago-hotel/pago-hotel.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { SegundaOpinionComponent } from '../../../dashboard/assistances/segunda-opinion/segunda-opinion.component';
import { MedicaTelefonicaComponent } from '../../../dashboard/assistances/medica-telefonica/medica-telefonica.component';
import { DefaultClickToCallComponent } from '../../../dashboard/assistances/default-click-to-call/default-click-to-call.component';

@Component({
  selector: 'app-service-request',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, AmbulanceAssistanceComponent, AmbulanceInternationalComponent, AmbulanceExtranjeroComponent, VialAssistanceComponent, MapComponent, HomeDoctorComponent, ReasonsLegalAssistanceComponent, MedicalCheckupComponent, SegundaOpinionComponent, MedicaTelefonicaComponent, MedicalReferencesComponent, UrgentMessagesComponent, MedicoDomicilioComponent, DiscountNetworkComponent, MedicalVirtualComponent, MedicalPsicotelefonicaComponent, MedicalComponent, TrasladoFamiliarComponent, PagoHotelComponent, DefaultClickToCallComponent],
  templateUrl: './service-request.component.html',
  styleUrl: './service-request.component.scss'
})
export class ServiceRequestComponent {
  serviceType: string = '';
  nameService: string = '';
  formType: string = '';
  hideHeader = false;

  // Variables para el mapa
  latitud: number | null = null;
  longitud: number | null = null;
  direccionSeleccionada: string = '';
  showMapSearchInput: boolean = false;
  isLoadingLocation: boolean = true;
  isEditingCurrentLocation: boolean = false;
  mapMovedManually: boolean = false;

  // Variables para chequeo médico
  fromMedicalCheckup: boolean = false;
  medicalCheckupData: any = null;
  laboratories: any[] = [];
  selectedLaboratoryId: string = '';
  selectedLaboratory: any = null;

  @ViewChild(MapComponent) mapComponent!: MapComponent;
  @ViewChild(MedicalCheckupComponent) medicalCheckupComponent!: MedicalCheckupComponent;
  //Maps current selected
  dataByCoordinates: any;
  catalogoCiudades: any[] = []; // De primer catálogo
  catalogoMunicipios: any[] = []; // Para los municipios
  ciudadIdSeleccionada: string = '';
  municipioIdSeleccionado: string = '';

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) { }

  ngOnInit() {
    // Debug: mostrar todos los parámetros de la URL
    console.log('Query params:', this.route.snapshot.queryParams);
    console.log('hideHeader param:', this.route.snapshot.queryParamMap.get('hideHeader'));
    
    this.initializeMedicalCheckupData();
    this.initializeServiceType();
    this.initializeLocation();
    //this.consultarCatalogo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Map ngOnChanges:', changes);
    if (changes['laboratories']) {
      console.log('Laboratorios cambiaron:', this.laboratories);

    }
  }
  private initializeMedicalCheckupData() {
    const state = history.state;
    console.log('Estado recibido en service-request:', state);
    if (state && state.fromMedicalCheckup) {
      this.fromMedicalCheckup = true;
      this.medicalCheckupData = state;
      this.laboratories = state.laboratories || [];
      console.log('Laboratorios en service-request:', this.laboratories);

      if (state.location) {
        if (state.location.id === 'current') {
          // Usar geolocalización actual
          this.initializeCurrentLocation();
        } else {
          // Usar ubicación seleccionada
          this.latitud = state.location.lat;
          this.longitud = state.location.lng;
          this.direccionSeleccionada = state.location.name;
          this.isLoadingLocation = false;
          console.log('Ubicación seleccionada:', this.latitud, this.longitud, this.direccionSeleccionada);

          // Actualizar el mapa después de que se inicialice
          setTimeout(() => {
            console.log('Intentando actualizar mapa con laboratorios:', this.laboratories);
            if (this.mapComponent) {
              console.log('MapComponent disponible, actualizando...');
              this.mapComponent.updateLocationAndLaboratories(this.latitud!, this.longitud!, this.laboratories);
            } else {
              console.log('MapComponent no disponible aún');
            }
          }, 2000);


        }
      }
    }
  }

  private initializeServiceType() {
    // Leer parámetro hideHeader de la URL
    const hideHeaderParam = this.route.snapshot.queryParamMap.get('hideHeader');
    const shouldHideHeader = hideHeaderParam === 'true';
    
    // Obtener datos del servicio desde state
    const serviceData = history.state;
    console.log('ServiceData from state:', serviceData);
    console.log('hideHeader param from URL:', hideHeaderParam);
    
    if (serviceData && serviceData.dsSubServicio) {
      console.log('Using service data from state');
      this.nameService = serviceData.dsSubServicio;
      this.serviceType = serviceData.dsSubServicio;
      this.hideHeader = shouldHideHeader || this.isBanamex() || this.shouldShowSpecialHeader(this.serviceType);
      this.formType = this.getFormType(this.serviceType);
    } else {
      // Fallback: obtener servicio por ID
      const serviceId = this.route.snapshot.paramMap.get('nombre');
      console.log('Service ID from URL:', serviceId);
      
      if (serviceId && this.isNumeric(serviceId)) {
        console.log('Service ID is numeric, getting service by ID');
        this.getServiceById(serviceId);
      } else {
        console.log('Service ID is not numeric, using fallback');
        // Fallback original para URLs con nombres
        this.serviceType = serviceId || this.getServiceFromUrl();
        this.mapServiceTypeName();
        this.nameService = this.serviceType;
        this.hideHeader = shouldHideHeader || this.isBanamex() || this.shouldShowSpecialHeader(this.serviceType);
        this.formType = this.getFormType(this.serviceType);
      }
    }
  }

  private isNumeric(str: string): boolean {
    return !isNaN(Number(str)) && !isNaN(parseFloat(str));
  }

  private getServiceById(serviceId: string) {
    console.log('Getting service by ID:', serviceId);
    
    // Mapeo directo de IDs conocidos a nombres de servicios
    const serviceMap: { [key: string]: string } = {
      // Ambulancia
      '223': 'Ambulancia',
      '241': 'Ambulancia',
      
      // Médicos
      '224': 'Médico a Domicilio',
      '225': 'Consultoría Médica Telefónica',
      '377': 'Check Up',
      '383': 'Consulta Médica en Consultorio',
      '433': 'Consulta Médica Virtual',
      
      // Viales
      '211': 'Arrastre de Grúa',
      '212': 'Paso de Corriente',
      '213': 'Cambio de Llanta',
      '214': 'Suministro de Gasolina',
      
      // Psicológicos
      '314': 'Asistencia Psicotelefónica',
      
      // Legales
      '292': 'Funeraria',
      '298': 'Asistencia Legal Funeraria',
      '254': 'Asistencia Legal Automovilística',
      
      // Viajes Internacionales
      '236': 'Repatriación por Fallecimiento',
      '239': 'Traslado de Familiar por Convalecencia',
      '324': 'Pago de Hotel',
      '322': 'Mensajes Urgentes',
      
      // Otros servicios
      '226': 'Referencias Médicas',
      '316': 'Mensajes Urgentes',
      '474': 'Red de Descuento',
      '376': 'Segunda Opinión'
    };

    const serviceName = serviceMap[serviceId];
    console.log('Found service name:', serviceName);
    
    if (serviceName) {
      // Leer parámetro hideHeader de la URL
      const hideHeaderParam = this.route.snapshot.queryParamMap.get('hideHeader');
      const shouldHideHeader = hideHeaderParam === 'true';
      
      this.nameService = serviceName;
      this.serviceType = serviceName;
      this.hideHeader = shouldHideHeader || this.isBanamex() || this.shouldShowSpecialHeader(serviceName);
      this.formType = this.getFormType(this.serviceType);
      console.log('Service configured:', {
        nameService: this.nameService,
        serviceType: this.serviceType,
        formType: this.formType,
        hideHeader: this.hideHeader,
        hideHeaderParam: hideHeaderParam
      });
    } else {
      console.log('Service not found in map, calling handleServiceNotFound');
      this.handleServiceNotFound();
    }
  }

  private handleServiceNotFound() {
    // Leer parámetro hideHeader de la URL
    const hideHeaderParam = this.route.snapshot.queryParamMap.get('hideHeader');
    const shouldHideHeader = hideHeaderParam === 'true';
    
    this.nameService = 'Servicio no encontrado';
    this.serviceType = 'Servicio no encontrado';
    this.formType = 'Asistencia';
    this.hideHeader = shouldHideHeader || this.isBanamex();
  }

  private getHeaders() {
    return new HttpHeaders({
      'Authorization': localStorage.getItem('accessToken') || '',
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
  }

  private mapServiceTypeName() {
    const serviceMap: { [key: string]: string } = {
      'home-doctor': 'Medico a Domicilio',
      'segunda-opinion': 'Segunda Opinión',
      'medica-telefonica': 'Consultoría Médica Telefónica',
      'referencias-medicas': 'Referencias Médicas',
      'mensajes-urgentes': 'Mensajes Urgentes',
      'medico-domicilio': 'Médico a Domicilio',
      'ambulancia-internacional': 'Ambulancia Internacional',
      'ambulancia-extranjero': 'Ambulancia (Extranjero)',
      'repatriacion': 'Repatriación',
      'traslado-familiar': 'Traslado de un familiar',
      'pago-hotel': 'Pago de Hotel',
      'medical-virtual': 'Consulta Médica Virtual'

    };

    if (serviceMap[this.serviceType]) {
      this.serviceType = serviceMap[this.serviceType];
    }
  }

  private initializeLocation() {
    if (!this.fromMedicalCheckup) {
      this.initializeCurrentLocation();
    }
  }

  // Método para inicializar la ubicación actual
  initializeCurrentLocation() {
    this.isLoadingLocation = true;
    if (navigator.geolocation) {
      // Opciones para obtener ubicación de alta precisión
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitud = position.coords.latitude;
        this.longitud = position.coords.longitude;
        this.direccionSeleccionada = 'Obteniendo dirección...';
        console.log('Ubicación obtenida con precisión:', position.coords.accuracy, 'metros');
        // Obtener dirección real usando geocodificación inversa
        this.getAddressFromCoordinates(this.latitud, this.longitud);
      }, (error) => {
        console.log('Error obteniendo geolocalización:', error);
        // Ubicación por defecto (Ciudad de México)
        this.latitud = 19.4326;
        this.longitud = -99.1332;
        this.direccionSeleccionada = 'Ubicación por defecto';
        this.getAddressFromCoordinates(this.latitud, this.longitud);
      }, options);
    } else {
      // Ubicación por defecto si no hay geolocalización
      this.latitud = 19.4326;
      this.longitud = -99.1332;
      this.direccionSeleccionada = 'Ubicación por defecto';
      this.getAddressFromCoordinates(this.latitud, this.longitud);
    }
  }

  // Método para obtener los datos del servicio
  getServiceData() {
    const state = history.state;
    return {
      clServicio: state?.clServicio || null,
      clSubServicio: state?.clSubServicio || null,
      dsServicio: state?.dsServicio || null,
      dsSubServicio: state?.dsSubServicio || null
    };
  }

  // Método para obtener dirección desde coordenadas
  getAddressFromCoordinates(lat: number, lng: number) {
    if (typeof google !== 'undefined' && google.maps) {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat, lng };
      
      geocoder.geocode({ location: latlng }, (results: any, status: any) => {
        if (status === 'OK' && results && results.length > 0) {
          let bestResult = results[0];
          
          for (let result of results) {
            const address = result.formatted_address;
            if (!address.match(/^[A-Z0-9]{4}\+[A-Z0-9]{2}/)) {
              if (address.match(/\d+/)) {
                bestResult = result;
                break;
              }
              if (!bestResult.formatted_address.match(/^[A-Z0-9]{4}\+[A-Z0-9]{2}/)) {
                bestResult = result;
              }
            }
          }
          
          this.direccionSeleccionada = bestResult.formatted_address;
          this.dataByCoordinates = bestResult;
        } else {
          this.direccionSeleccionada = 'Mi ubicación actual';
        }
        this.isLoadingLocation = false;
      });
    } else {
      this.direccionSeleccionada = 'Mi ubicación actual';
      this.isLoadingLocation = false;
    }
  }

  private getServiceFromUrl(): string {
    // Obtener el parámetro directamente de la ruta
    let serviceName = this.route.snapshot.params['nombre'];
    
    if (!serviceName) {
      // Fallback: obtener de la URL completa
      let url = this.route.snapshot.url.join('/');
      serviceName = url.split('/').pop()?.split('?')[0] || '';
    }
    
    // Decodificar el nombre del servicio y corregir URL si es necesario
    let decodedName = serviceName;
    try {
      let previousName = '';
      let attempts = 0;
      while (decodedName !== previousName && decodedName.includes('%') && attempts < 10) {
        previousName = decodedName;
        decodedName = decodeURIComponent(decodedName);
        attempts++;
      }
      
      // Si la URL estaba mal codificada, corregirla
      if (decodedName !== serviceName && window.location.pathname.includes(serviceName)) {
        const currentUrl = window.location.href;
        const correctedUrl = currentUrl.replace(serviceName, encodeURIComponent(decodedName));
        window.history.replaceState(null, '', correctedUrl);
      }
    } catch (e) {
      console.warn('Error decodificando nombre del servicio:', e);
      decodedName = serviceName;
    }

    // Mapeo directo por nombre
    if (decodedName.includes('ambulancia-internacional')) return 'ambulancia-internacional';
    if (decodedName.includes('ambulancia-extranjero')) return 'ambulancia-extranjero';
    if (decodedName.includes('Repatriación')) return 'Repatriación';
    if (decodedName.includes('traslado-familiar') || decodedName.includes('Traslado de Familiar')) return 'traslado-familiar';
    if (decodedName.includes('pago-hotel')) return 'pago-hotel';

    if (decodedName.includes('ambulance')) return 'Ambulancia';
    if (decodedName.includes('vial')) return 'Arrastre de Grúa';
    if (decodedName.includes('home-doctor')) return 'Medico a Domicilio';
    if (decodedName.includes('segunda-opinion')) return 'Segunda Opinión';
    if (decodedName.includes('medica-telefonica')) return 'Consultoría Médica Telefónica';
    if (decodedName.includes('referencias-medicas')) return 'Referencias Médicas';
    if (decodedName.includes('medical-virtual')) return 'Consulta Médica Virtual';
    if (decodedName.includes('medical-psicotelefonica')) return 'Consulta Médica Psicotelefonica';
    if (decodedName === 'medical') return 'Consulta Médica en Consultorio';

    // Retornar el nombre decodificado directamente
    return decodedName;
  }

  private getFormType(type: string): string {
    // Decodificar el tipo si viene codificado
    let decodedType = type;
    try {
      while (decodedType.includes('%')) {
        const previousType = decodedType;
        decodedType = decodeURIComponent(decodedType);
        if (decodedType === previousType) break;
      }
    } catch (e) {
      decodedType = type;
    }

    switch (decodedType) {
      case 'Ambulancia': return 'Ambulancia';
      case 'Ambulancia Internacional': return 'Ambulancia';
      case 'Ambulancia (Extranjero)': return 'Ambulancia (Extranjero)';
      case 'Repatriación':
      case 'Repatriación por Fallecimiento': return 'Repatriación';
      case 'Traslado de un familiar':
      case 'Traslado de Familiar por Convalecencia': return 'Traslado de un familiar';
      case 'Pago de Hotel': return 'Pago de Hotel';

      case 'Arrastre de Grúa':
      case 'Paso de Corriente':
      case 'Cambio de Llanta':
      case 'Suministro de Gasolina':
        return 'Arrastre de Grúa';
      case 'home-doctor':
      case 'Medico a Domicilio':
        return 'Medico a Domicilio';
      case 'Check-up Médico':
      case 'Check Up':
        return 'Check-up Médico';
      case 'Asistencia Legal Automovilística':
        return 'Asistencia Legal Automovilística';
      case 'Funeraria':
        return 'Funeraria';
      case 'Asistencia Legal Funeraria':
        return 'Asistencia Legal Funeraria';
      case 'Segunda Opinión':
        return 'Segunda Opinión';
      case 'Consultoría Médica Telefónica':
        return 'Consultoría Médica Telefónica';
      case 'Referencias Médicas':
        return 'Referencias Médicas';
      case 'Mensajes Urgentes':
        return 'Mensajes Urgentes';
      case 'Médico a Domicilio':
        return 'Médico a Domicilio';
      case 'Red de Descuento':
        return 'Red de Descuento';
      case 'Consulta Médica Virtual':
        return 'Consulta Médica Virtual';
      case 'Asistencia Psicotelefónica':
        return 'Asistencia Psicotelefónica';
      case 'Consulta Médica en Consultorio':
        return 'Consulta Médica en Consultorio';
      default: return 'Asistencia';
    }
  }

  // Métodos para manejar eventos del mapa
  getPlaces(places: any) {
    console.log('Ubicación seleccionada por búsqueda:', places);
    if (places && places.geometry && places.geometry.location) {
      this.latitud = places.geometry.location.lat;
      this.longitud = places.geometry.location.lng;
      this.direccionSeleccionada = places.formatted_address || places.name || '';
    }
  }

  getReverseByCordinates(coordinates: any) {
    console.log('Coordenadas por movimiento de pin:', coordinates);
    if (coordinates && coordinates.lat && coordinates.lng) {
      this.latitud = coordinates.lat;
      this.longitud = coordinates.lng;
      this.mapMovedManually = true;
      // Reset después de un breve delay para permitir que el componente hijo reaccione
      setTimeout(() => {
        this.mapMovedManually = false;
      }, 100);
    }
  }

  getReverseByAddress(address: any) {
    console.log('Dirección obtenida por coordenadas:', address);
    if (address && address.display_name) {
      this.direccionSeleccionada = address.display_name;
    } else if (address && address.formatted_address) {
      this.direccionSeleccionada = address.formatted_address;
    }
    this.dataByCoordinates = address;
    //this.obtenerMunicipios(address);

  }

  // Método para obtener las coordenadas actuales
  getCurrentLocation() {
    return {
      lat: this.latitud,
      lng: this.longitud,
      address: this.direccionSeleccionada
    };
  }

  // Método para obtener la ubicación actual del mapa como dirección
  getCurrentMapLocation() {
    if (this.latitud && this.longitud) {
      return {
        lat: this.latitud,
        lng: this.longitud,
        colony: 'Ubicación actual',
        streetNumber: '',
        identifier: this.direccionSeleccionada || 'Ubicación seleccionada en el mapa',
        city: '',
        isCurrentLocation: true,
        place: this.dataByCoordinates,
        postalCode: this.extractPostalCode(),
        codeMunicipio: this.municipioIdSeleccionado,
        codeEstado: this.ciudadIdSeleccionada
      };
    }
    return null;
  }

  private extractPostalCode(): string {
    if (!this.dataByCoordinates) return '';
    // Google Geocoding API: address_components
    if (this.dataByCoordinates.address_components) {
      const postalComponent = this.dataByCoordinates.address_components.find(
        (c: any) => c.types?.includes('postal_code')
      );
      if (postalComponent) return postalComponent.long_name || postalComponent.short_name || '';
    }
    // OpenStreetMap Nominatim
    if (this.dataByCoordinates.address?.postcode) {
      return this.dataByCoordinates.address.postcode;
    }
    return '';
  }

  // Método para manejar la selección de dirección desde los componentes hijos
  onAddressSelected(addressData: any) {
    console.log('Dirección seleccionada:', addressData);
    console.log('MapComponent disponible:', !!this.mapComponent);
    this.latitud = addressData.lat;
    this.longitud = addressData.lng;
    this.direccionSeleccionada = addressData.address;

    // Siempre actualizar el centro del mapa, incluso si es la misma dirección
    this.updateMapCenter(addressData.lat, addressData.lng);
  }

  // Método para actualizar el centro del mapa
  updateMapCenter(lat: number, lng: number) {
    if (this.mapComponent) {
      // Forzar actualización del mapa incluso si las coordenadas son las mismas
      this.mapComponent.updateLocation(lat, lng);
    }
  }

  // Método para habilitar el buscador del mapa
  enableMapSearch() {
    this.showMapSearchInput = true;
    // Reinicializar el autocompletado cuando se habilita el buscador
    if (this.mapComponent) {
      this.mapComponent.reinitializeAutocomplete();
    }
  }

  // Método para deshabilitar el buscador del mapa
  disableMapSearch() {
    this.showMapSearchInput = false;
  }

  // Método para verificar si es asistencia legal
  isLegalAssistance(): boolean {
    return this.formType === 'Asistencia Legal Automovilística' || this.formType === 'Funeraria' || this.formType === 'Asistencia Legal Funeraria';
  }



  // Método para verificar si es segunda opinión
  isSegundaOpinion(): boolean {
    return this.formType === 'Segunda Opinión';
  }

  isConsultoriaMedicaTelefonica(): boolean {
    return this.formType === 'Consultoría Médica Telefónica';
  }

  isMedicalReferences(): boolean {
    return this.formType === 'Referencias Médicas';
  }

  isUrgentMessages(): boolean {
    return this.formType === 'Mensajes Urgentes';
  }

  isMedicoDomicilio(): boolean {
    return this.formType === 'Médico a Domicilio';
  }

  isTrasladoFamiliar(): boolean {
    return this.formType === 'Traslado de un familiar';
  }

  isPagoHotel(): boolean {
    return this.formType === 'Pago de Hotel';
  }


  // Método para verificar si es check-up médico
  isMedicalCheckup(): boolean {
    return this.formType === 'Check-up Médico';
  }

  // Método para verificar si es ambulancia internacional
  isAmbulanciaInternacional(): boolean {
    return this.formType === 'Ambulancia Internacional';
  }

  // Método para verificar si es ambulancia extranjero
  isAmbulanciaExtranjero(): boolean {
    return this.formType === 'Ambulancia (Extranjero)';
  }

  // Método para verificar si es repatriación
  isRepatriacion(): boolean {
    return this.formType === 'Repatriación';
  }

  // Método para verificar si Asistencia Psicotelefónica
  isConsultaMedicaPsicotelefonica(): boolean {
    return this.formType === 'Asistencia Psicotelefónica';
  }

  // Método para verificar si es CONSULTA MÉDICA
  isConsultaMedica(): boolean {
    return this.formType === 'Consulta Médica en Consultorio';
  }

  // Métodos para manejar selección de laboratorios
  selectLaboratory(laboratory: any) {
    this.selectedLaboratoryId = laboratory.id;
    this.selectedLaboratory = laboratory;

    // Centrar el mapa en el laboratorio seleccionado
    if (this.mapComponent && laboratory.lat && laboratory.lng) {
      this.mapComponent.updateLocation(laboratory.lat, laboratory.lng, laboratory.name);
    }
  }

  confirmLaboratorySelection() {
    if (this.selectedLaboratory && this.medicalCheckupData) {
      // Navegar a confirmación con todos los datos
      const mockServiceResponse = {
        id: Math.floor(Math.random() * 100000),
        fechaapertura: new Date().toISOString(),
        telefono1: '+525555555555'
      };

      this.router.navigate(['/service/confirm/', 'Check-up Médico'], {
        state: {
          patient: this.medicalCheckupData.patient,
          patientName: this.medicalCheckupData.patientName,
          serviceName: 'Check-up Médico',
          study: this.medicalCheckupData.study,
          laboratory: this.selectedLaboratory,
          location: this.medicalCheckupData.location,
          fromSelection: true,
          serviceResponse: mockServiceResponse
        }
      });
    }
  }



  isDiscountNetwork(): boolean {
    return this.formType === 'Red de Descuento';
  }

  isBanamex(): boolean {
    const allowedAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
    const account = localStorage.getItem('account');
    return account ? allowedAccounts.includes(account) : false;
  }

  shouldShowSpecialHeader(serviceType: string): boolean {
    // Verificar si la ruta es /service/[número]
    const serviceId = this.route.snapshot.paramMap.get('nombre');
    if (serviceId && this.isNumeric(serviceId)) {
      return true; // Todas las rutas /service/[ID] muestran header especial
    }
    
    // Servicios específicos que también deben mostrar el header especial
    const specialHeaderServices = [
      'Asistencia Legal Automovilística',
      'Funeraria', 
      'Asistencia Legal Funeraria'
    ];
    return specialHeaderServices.includes(serviceType);
  }

  isConsultaMedicaVirtual(): boolean {
    return this.formType === 'Consulta Médica Virtual';
  }

  // Método para recibir laboratorios del medical-checkup (solo para Check-up Médico)
  onLaboratoriesFound(data: any) {
    console.log('🗺️ onLaboratoriesFound recibido:', data);
    
    if (!this.isMedicalCheckup()) return;
    
    const laboratories = data.laboratories || [];
    const centerLocation = data.centerLocation;
    
    this.laboratories = laboratories;
    console.log('🗺️ Laboratorios:', laboratories.length, 'Centro:', centerLocation);

    if (!this.mapComponent) {
      console.log('🗺️ MapComponent no disponible, reintentando...');
      setTimeout(() => this.onLaboratoriesFound(data), 200);
      return;
    }
    
    const lat = centerLocation?.lat || this.latitud || 19.4326;
    const lng = centerLocation?.lng || this.longitud || -99.1332;
    
    if (laboratories.length > 0) {
      // Mostrar laboratorios en el mapa
      console.log('🗺️ Mostrando', laboratories.length, 'laboratorios en el mapa');
      this.mapComponent.updateLocationAndLaboratories(lat, lng, laboratories);
    } else {
      // Solo mover el mapa al centro (sin laboratorios)
      console.log('🗺️ Moviendo mapa al centro:', lat, lng);
      this.mapComponent.updateLocationAndLaboratories(lat, lng, []);
    }
  }

  // Método para manejar selección de laboratorio desde el mapa (solo para Check-up Médico)
  onLaboratorySelectedFromMap(laboratoryMarker: any) {
    if (this.formType !== 'Check-up Médico') return;

    console.log('Laboratorio seleccionado desde el mapa:', laboratoryMarker);
    if (laboratoryMarker.laboratoryData) {
      this.selectLaboratory(laboratoryMarker.laboratoryData);
      // Notificar al formulario medical-checkup
      this.notifyLaboratorySelection(laboratoryMarker.laboratoryData);
    }
  }

  // Método para manejar selección de laboratorio desde el formulario
  onLaboratorySelectedFromForm(laboratory: any) {
    if (this.formType !== 'Check-up Médico') return;

    console.log('Laboratorio seleccionado desde el formulario:', laboratory);
    this.selectLaboratory(laboratory);
  }

  // Método para manejar cuando los marcadores del mapa se han cargado
  onMarkersLoaded(loaded: boolean) {
    if (loaded && this.formType === 'Check-up Médico' && this.medicalCheckupComponent) {
      this.medicalCheckupComponent['loader'].hide();
    }
  }

  // Método para notificar selección al formulario medical-checkup
  private notifyLaboratorySelection(laboratory: any) {
    setTimeout(() => {
      if (this.medicalCheckupComponent) {
        this.medicalCheckupComponent.updateSelectedLaboratory(laboratory);
        console.log('Laboratorio actualizado en formulario:', laboratory);
      }
    }, 100);
  }

  // Método para consultar el catálogo de ciudades
  /*
  consultarCatalogo() {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;
    const account = localStorage.getItem('account');

    const headers = new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        idCatalogo: 21,
        parametros: [
          {
            clCuenta: account
          }
        ]
      }
    };

    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.catalogoCiudades = response.catalogo;
        localStorage.setItem('catalogoCiudades', JSON.stringify(this.catalogoCiudades));
      },
      error: (error) => {
        console.error('Error al consultar catálogo de ciudades:', error);
      }
    });
  }

  obtenerMunicipios(address: any) {
    const codificadoPorpin = address?.address
    let estado = '';
    if (codificadoPorpin) {
      const estadoEncontrado = this.syncAddresSatateWithCatalogs(address);
      estado = estadoEncontrado.id;
    } else {
      estado = this.ciudadIdSeleccionada
    }
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;

    const headers = new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        idCatalogo: 41,
        parametros: [
          {
            codEnt: estado
          }
        ]
      }
    };

    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.catalogoMunicipios = response.catalogo;
        //merge con catalogo de municipios
        const municipioEncontrado = this.syncAddresMunicipioWithCatalogs(address);
      },
      error: (error) => {
        console.error('Error al consultar catálogo de municipios:', error);
      }
    });

  }

  syncAddresMunicipioWithCatalogs(address: any) {
    const adrressPorpin = address?.address
    if (adrressPorpin) {
      const MunicipioDeseMapa = this.normalizeEstado(address.address.borough || address.address.county || '');
      const municipioEncontrado = this.catalogoMunicipios.find((item: any) => {
        return this.normalizeEstado(item.descripcion) === MunicipioDeseMapa;
      });
      if (municipioEncontrado) {
        this.municipioIdSeleccionado = municipioEncontrado;
      }
      return municipioEncontrado;
    } else {
      return null;

    }
  }


  syncAddresSatateWithCatalogs(address: any) {
    const estadoDesdeMapa = this.normalizeEstado(address.address.state || '');
    const estadoEncontrado = this.catalogoCiudades.find((item: any) => {
      const descripcionNormalizada = this.normalizeEstado(item.descripcion);
      return descripcionNormalizada === estadoDesdeMapa;
    });

    if (estadoEncontrado) {
      this.ciudadIdSeleccionada = estadoEncontrado;
    } else {
      console.warn('No se encontró el estado en el catálogo:', estadoDesdeMapa);
    }
    return estadoEncontrado;
  }

  normalizeEstado(estado: string): string {
    if (!estado) return '';
    return estado
      .toUpperCase()
      .normalize("NFD")                      // Quitar acentos
      .replace(/[\u0300-\u036f]/g, "")      // Quitar acentos
      .replace(/[^A-Z\s]/g, "")             // Quitar símbolos
      .replace(/\b(ESTADO\s+DE|ESTADO|DE)\b/g, "")// Quitar palabras comunes
      .replace(/\s+/g, " ")                 // Quitar espacios dobles
      .trim();
  }
  */

  // HARDCODED: Getter para cambiar "CONSULTA MÉDICA" por "CONSULTA MÉDICA EN CONSULTORIO"
  get displayNameService(): string {
    if (this.nameService === 'CONSULTA MÉDICA EN CONSULTORIO') {
      return 'Consulta Médica en Consultorio';
    }
    return this.nameService;
  }
  // ORIGINAL: Para revertir, usar directamente this.nameService en el HTML

}


